import { CorporationDto } from '../corporation/corporation.dto';
import { CorporatePermissionDto } from '../permission/corporate-permission.dto';

export interface CorporateRoleDto {
  id: string; // Guid
  corporationId: string; // Guid
  name: string;
  description?: string | null;
  isActive: boolean;
  isDefault: boolean;
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
  corporation?: CorporationDto | null;
  permissions?: CorporatePermissionDto[] | null;
}
